/* @flow */
import { Signature } from 'constants/CopyConstants';
import Button from 'components/Button.jsx';
import Columns2 from 'components/Columns2.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import Legend from 'components/Legend.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import React from 'react';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import SettingsContainer from './SettingsContainer.jsx';

type Props = {
  loading?: ?boolean,
  error?: ?Object,
  user?: ?{
    id: number | string, // https://github.com/remind101/r101-api/pull/8771
    signature: string,
  },
  saveSignature: (signature: string) => Promise<*>,
};

export class UserSignatureForm extends React.Component {
  props: Props;

  state = {
    canSubmit: false,
    hasChanged: false,
  };

  // XXX until we have a good mechanism for GraphQL errors (e.g. re-auth)
  // https://apollographql.slack.com/archives/general/p1478732615013498
  // FIXME(turadg)
  componentWillReceiveProps(nextProps: Object) {
    if (!this.props.error && nextProps.error) {
      ToastActions.showDefaultErrorToast();
      console.warn(nextProps);
      console.error('GraphQL error');
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    if (this.state.hasChanged) {
      this.setState({ canSubmit: true });
    }
  };

  enableChanged = () => {
    this.setState({ hasChanged: true });
  };

  reset = () => {
    this.disableButton();
    this.setState({ hasChanged: false });
  };

  submit = (values: {signature: string}) => {
    this.reset();

    const { saveSignature } = this.props;

    saveSignature(values.signature)
    .then(() => ToastActions.showSuccessToast('Signature saved'))
    .catch(ToastActions.showDefaultErrorToast);
  };

  render() {
    if (!this.props.user) {
      return <LoadingIndicator />;
    }

    return (
      <Form
        onValidSubmit={this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        onChange={this.enableChanged}>
        <Fieldset>
          <Legend>
            Signature
            <p>{Signature.explanation}</p>
          </Legend>

          <SettingsContainer>
            <Columns2 gutter="small">
              <div>
                <FormInput
                  required
                  name="signature"
                  showErrorOnPristine
                  className="UserSignatureForm-signature"
                  value={this.props.user.signature}
                  validations={{ maxLength: 18 }}
                  validationErrors={{
                    maxLength: 'Signature can’t be longer than 18 characters.',
                  }}
                />
              </div>
            </Columns2>
          </SettingsContainer>

          <Button
            size="small"
            type="submit"
            className="UserSignatureForm-signature-submit"
            disabled={!this.state.canSubmit}
            eventElementName="UserSignatureForm-signature-submit">
            Save
          </Button>
        </Fieldset>
      </Form>
    );
  }
}

const withMutations = graphql(gql`
  mutation updateSignature($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        signature
      }
      error {
        message
      }
    }
  }
  `, {
    props({ mutate }) {
      return {
        saveSignature(signature: string) {
          const input = { signature };
          return mutate({ variables: { input } }).then(({ data: { updateUser } }) => {
            if (updateUser.error) {
              throw new Error(updateUser.error.message);
            }
            // while we support the CurrentUser store
            UserActions.updateLocal({ signature });
          });
        },
      };
    },
  }
);

const withUser = graphql(gql`
  query {
    user: me {
      id
      signature
    }
  }
  `, {
    // TODO decide whether to make this the default `props` function
    props: ({ data }) => data,
  }
);

export default withMutations(withUser(UserSignatureForm));



// WEBPACK FOOTER //
// ./src/settings/components/UserSignatureForm.jsx